export var FormData;
(function (FormData) {
    function to(data) {
        const result = new globalThis.FormData();
        result.append("*", new globalThis.Blob([new TextEncoder().encode(JSON.stringify(toHelperObject(data, "", result)))], {
            type: "application/json; charset=utf-8",
        }));
        return result;
    }
    FormData.to = to;
    function toHelperObject(data, name, form) {
        return Object.entries(data).reduce((result, [key, value]) => {
            value instanceof Blob
                ? form.append(name ? `${name}.${key}` : key, value)
                : typeof value == "object" && value
                    ? Array.isArray(value)
                        ? (result[key] = toHelperArray(value, name ? `${name}.${key}` : key, form))
                        : (result[key] = toHelperObject(value, name ? `${name}.${key}` : key, form))
                    : (result[key] = value);
            return result;
        }, {});
    }
    function toHelperArray(data, name, form) {
        return data.reduce((result, value) => {
            typeof value == "object" && value
                ? Array.isArray(value)
                    ? result.push(toHelperArray(value, name, form))
                    : result.push(toHelperObject(value, name, form))
                : result.push(value);
            return result;
        }, []);
    }
    async function from(form) {
        const result = {};
        for (const [name, value] of form.entries())
            await set(result, name.split("."), value);
        return result;
    }
    FormData.from = from;
    async function set(data, [head, ...tail], value) {
        if (tail.length == 0)
            value instanceof Blob && value.type.startsWith("application/json")
                ? head == "*"
                    ? merge(data, JSON.parse(await value.text()))
                    : typeof data[head] == "object" && data[head]
                        ? merge(data[head], JSON.parse(await value.text()))
                        : (data[head] = JSON.parse(await value.text()))
                : (data[head] = value);
        else
            set(typeof data[head] == "object" && data[head] ? data[head] : (data[head] = {}), tail, value);
    }
    function merge(target, ...sources) {
        if (sources.length) {
            const [head, ...tail] = sources;
            Object.entries(head).forEach(([key, value]) => isObject(value)
                ? merge(isObject(target[key]) ? target[key] : (target[key] = {}), value)
                : (target[key] = head[key]));
            merge(target, ...tail);
        }
    }
    function isObject(value) {
        return value && typeof value == "object" && !Array.isArray(value);
    }
    FormData.isObject = isObject;
})(FormData || (FormData = {}));
//# sourceMappingURL=FormData.js.map